import { render, staticRenderFns } from "./SolicitarCotizacion.vue?vue&type=template&id=70612bb5"
import script from "./SolicitarCotizacion.vue?vue&type=script&lang=js"
export * from "./SolicitarCotizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports